import {BaseWidget} from "./BaseWidget";
import {copyToClipoard} from "./Utils";
import {DmsCL} from "./generated/DmsCL";
import {UiRadioList} from "./components/UiRadioList";
import {UiFlashMessage} from "./UiFlashMessage";

export class UiProjectImport extends BaseWidget
{
	// @ts-ignore
	public clUrl: string;
	// @ts-ignore
	private cl: DmsCL;
	private lastStatus: "ok" | "warning" | "error" = "ok";
	beforeIndex() {
		this.cl = new DmsCL(this.clUrl);
		this.container.classList.add('project-import');
		this.muAppendContent(`
			<div class="project-import__src-data" mu-id="pSrcData">
				<div class="row form-group">
					<label class="col-md-3">Firma:</label>
					<div class="col-md-9">
						<div mu-widget="UiRadioList" mu-id="buSubject" class="checkbox"></div>
					</div>
				</div>
				<div class="form-group">
					<label mu-for="srcData">Zdrojová data:</label>
					<textarea mu-id="srcData" placeholder="Sem zkopírujte zdrojová data" class="form-control"></textarea>
				</div>
				<div class="buttons"><span class="btn btn-primary" mu-id="bCheck">Zkontrolovat</span></div>
			</div>
			<div mu-id="pPreview">
				<h2 class="_icon-before-warning _icon-before--autosize">Výsledek kontroly: <span mu-id="checkResult"></span></h2>
				<div class="buttons">
					<span class="btn btn-primary" mu-id="bImport">Importovat</span>
					<span class="btn btn-default" mu-id="bBack">Zpět</span>
				</div>
				<ul mu-bind="messages:@foreach">
					<li mu-template="item" mu-widget=".">
						<code mu-bind="cellCode"></code>
						<span mu-bind="message;type:className"></span>
					</li>
				</ul>
			</div>
			<div>
				<h2>Šablona importního souboru</h2>
				<span class="a icon-before-copy" mu-id="bCopy">Zkopírovat</span>
				<table class="table" mu-id="exampleTable">
					<tr>
						<th>Kód</th>
						<th>Název</th>
						<th>Kód střediska</th>
						<th>Středisko</th>
						<th>Obchodní manažer NWT</th>
						<th>Projektový manažer NWT</th>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
				</table>
			</div>
		`);
	}

	async afterIndex() {
		this.setMode("srcData");
		(this.muNamedWidget.buSubject as unknown as UiRadioList).bindItems(
			(await this.cl.getMyBuSubjects()).write.map(bsu => ({ id: bsu.id, title: bsu.name }))
		);
	}

	async bCheck_click() {
		const buSubjectId = (this.muNamedWidget.buSubject as unknown as UiRadioList).value;
		if (buSubjectId == null) {
			UiFlashMessage.instance.add("Vyberte firmu");
			return;
		}
		if (!this.ui.srcData.value) {
			UiFlashMessage.instance.add("Zadejte zdrojová data");
			return;
		}
		const data = await this.cl.checkProjectsImport(this.ui.srcData.value, parseInt(buSubjectId));
		this.muBindData(data);
		this.setMode("preview");
		this.muVisible(data.status !== "error", "bImport");
		this.lastStatus = data.status;
		const resMsg = {
			ok: "v pořádku",
			warning: "drobné chyby",
			error: "vážné chyby",
		};
		this.ui.checkResult.innerText = resMsg[this.lastStatus];
	}

	async bImport_click() {
		if (this.lastStatus === "ok" || confirm("V importu jsou drobné chyby, chcete přesto naiportovat?")) {
			const buSubjectId = (this.muNamedWidget.buSubject as unknown as UiRadioList).value;
			// @ts-ignore
			await this.cl.projectsImport(this.ui.srcData.value, parseInt(buSubjectId));
			UiFlashMessage.instance.add("Naimportováno");
		}
	}

	bBack_click() {
		this.setMode("srcData");
	}

	bCopy_click() {
		copyToClipoard(this.ui.exampleTable.outerHTML, 'html');
	}

	private setMode(mode: "srcData"|"preview") {
		this.muVisible(
			mode == "preview",
			[ "pPreview", "!pSrcData" ]
		)
	}
}
